module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Teilnahme.9e56e9af.svg";